angular.module('app')
  .factory('lookupFactory', function ($http) {
    return {
      findCompanies(keyword) {
        return $http.get('/api/v3/find/companies', { params: { starts_with: keyword } }).then((response) => response.data);
      },
    };
  });
